import { NoteItem } from "../../../components/notes/hooks/state/NoteItem";
import { NoteSource } from "../../../components/notes/hooks/state/NoteSource";
import { NoteItemResponse } from "./GetNotesResponse";

export type AssetNoteItemResponse = NoteItemResponse & {
    source: NoteSource;
};

export type GetNotesByAssetsResponse = Record<string, AssetNoteItemResponse[]>;

export const mapToNoteItem = (response: AssetNoteItemResponse, subjectId: string): NoteItem => ({
    id: response.id,
    author: response.author,
    content: response.content,
    creationDate: response.creationDate,
    source: response.source,
    subjectId
});
